import { useApp } from "@/context/AppContext";

export const QuotaPill = () => {
  const { user, quota } = useApp();
  const loading = !!user && !quota;
  const remaining = user && quota ? quota.remaining : 1;
  const limit = user && quota ? quota.limit : 1;
  const dot = remaining > 0 ? "bg-emerald-400" : "bg-rose-400";
  return (
    <span
      className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-emerald-400/25 bg-emerald-500/[0.07] px-3 py-1.5 text-xs font-medium text-emerald-200"
      data-testid="quota-pill"
      title="1 Free Assessment"
    >
      <span className={`h-2 w-2 rounded-full ${dot} animate-pulse`} aria-hidden="true" />
      <span><span className="hidden sm:inline">Founder Workspace (</span><span data-testid="quota-pill-value">{loading ? "…" : `${remaining}/${limit}`}</span> Free Left<span className="hidden sm:inline">)</span></span>
    </span>
  );
};
